import React, { Component } from 'react';
import Carousel from './Carousel'
import Grid from './Grid'
import MobileCarousel from './MobileCarousel'
import WebCarousel from './WebCarousel'
import WebGrid from './WebGrid'
import withAds from './HOCs/withAds'
import './index.css'

class Pimper extends Component {

  renderGallery(platform, orientation, object_name, galleryResponse, shouldFacelift=false) {
    if (platform === 'msite') {
      return <MobileCarousel {...this.props} galleryResponse={galleryResponse} />
    }
    else if (platform === 'web') {
      if (orientation === 'grid') {
        if (object_name === 'home' && shouldFacelift === true) {
          return (
            <div className="facelift">
              <WebGrid {...this.props} galleryResponse={galleryResponse} />
            </div>
          )
        }
        else {
          return <Grid {...this.props} galleryResponse={galleryResponse} />
        }
      }
      else if (object_name === 'home' && shouldFacelift === true) {
        return (
            <div className="facelift">
              <WebCarousel {...this.props} galleryResponse={galleryResponse} />
            </div>
          )
      }
      else {
        return <Carousel  {...this.props} galleryResponse={galleryResponse} />
      }
    }
    else {
      return <Carousel  {...this.props} galleryResponse={galleryResponse} />
    }
  }
  
  render() {
    const {
      platform,
      orientation,
      object_name,
      response,
      shouldFacelift
    } = this.props

    if (!response.length) return null

    return (
      <div>
        {response.map((resp, idx) => (
          <div key={idx} className='rec-gallery'>
            {this.renderGallery(platform, resp.orientation || orientation, object_name, resp, shouldFacelift)}
          </div>
         )
        )}
      </div>
    )
  }
}

export default withAds(Pimper);


// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/Pimper.js